// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how-it-works {
  background: #fff;
  padding: clamp(64px, 8vw, 120px) clamp(24px, 5vw, 56px);
}

.how-it-works__title {
  margin: 0 0 clamp(48px, 6vw, 80px);
  font-family: 'Averia Serif Libre', Georgia, serif;
  font-size: clamp(2rem, 3.5vw, 3.5rem);
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: -0.02em;
  text-align: center;
  color: #2c1810;
}

.how-it-works__steps {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: clamp(8px, 1.5vw, 24px);
  max-width: 1400px;
  margin: 0 auto;
  padding: 0;
  list-style: none;
}

.how-it-works__step {
  flex: 0 1 clamp(280px, 34vw, 440px);
  transform: rotate(var(--step-rotation, 0deg));
}

.how-it-works__step img {
  display: block;
  width: 100%;
  height: auto;
  mix-blend-mode: screen;
}

@media (max-width: 768px) {
  .how-it-works__steps {
    flex-direction: column;
    gap: 20px;
  }

  .how-it-works__step {
    flex-basis: min(360px, 90vw);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HowItWorks/HowItWorks.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,kCAAkC;EAClC,iDAAiD;EACjD,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".how-it-works {\n  background: #fff;\n  padding: clamp(64px, 8vw, 120px) clamp(24px, 5vw, 56px);\n}\n\n.how-it-works__title {\n  margin: 0 0 clamp(48px, 6vw, 80px);\n  font-family: 'Averia Serif Libre', Georgia, serif;\n  font-size: clamp(2rem, 3.5vw, 3.5rem);\n  font-weight: 400;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  text-align: center;\n  color: #2c1810;\n}\n\n.how-it-works__steps {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(8px, 1.5vw, 24px);\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0;\n  list-style: none;\n}\n\n.how-it-works__step {\n  flex: 0 1 clamp(280px, 34vw, 440px);\n  transform: rotate(var(--step-rotation, 0deg));\n}\n\n.how-it-works__step img {\n  display: block;\n  width: 100%;\n  height: auto;\n  mix-blend-mode: screen;\n}\n\n@media (max-width: 768px) {\n  .how-it-works__steps {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .how-it-works__step {\n    flex-basis: min(360px, 90vw);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
